export default {
    'menu.welcome': 'Welcome',
    'menu.more-blocks': 'More Blocks',
    'menu.home': 'Home',
    'menu.admin': 'Admin',
    'menu.admin.sub-page': 'Sub-Page',
    'menu.login': 'Login',
    'menu.register': 'Register',
    'menu.register-result': 'Register Result',

    'menu.dashboard': 'Home',
    'menu.dashboard.overview': 'General',
    'menu.dashboard.analytic': 'Analytic',
    'menu.dashboard.financial': 'Financial',

    'menu.motor': 'Motor',
    'menu.motor.sales': 'Sales',
    'menu.motor.sales.new': 'New Sales',
    'menu.motor.sales.new.tpl': 'TPL',
    'menu.motor.sales.new.casco': 'Casco',
    'menu.motor.sales.new.other': 'Other',
    'menu.motor.sales.list': 'List',
    'menu.motor.sales.lista-e-drafteve': 'Draft List',
    'menu.motor.sales.renewals': 'Renewals',
    'menu.motor.claims': 'Claims',
    'menu.motor.claims.new': 'New practice',
    'menu.motor.claims.list': 'Claims List',
    'menu.motor.claims.list-events': 'List of events',
    'menu.motor.configurations': 'Configurations',
    'menu.motor.configurations.fleets': 'Fleets',
    'menu.casco': 'Casco',
    'menu.daily-casco': 'Daily Casco',
    'menu.minicasco': 'Mini Casco',
    'menu.fpp': 'FPP',
    'menu.tpl': 'TPL',
    'menu.tpl-v1': 'Old TPL',
    'menu.green_card': 'Green Card',
    'menu.border': 'Border',
    'menu.passenger': 'Passenger',
    'menu.autosos': 'Autosos',

    'menu.mvl': 'MVL',
    'menu.cargo-in-transit': 'Cargo in Transit',
    'menu.cmr': 'CMR',
    'menu.hm': 'HM',
    'menu.pi': 'PI',
    'menu.aviation-casco': 'Aviation Casco',
    'menu.aviation-tpl': 'Aviation TPL',

    'menu.new': 'New',
    'menu.new.new': 'New Policy',
    'menu.professional': 'Professional',
    'menu.new.professional': 'Professional',

    'menu.property': 'Property',
    'menu.property.sales': 'Sales',
    'menu.property.sales.new': 'New Sales',
    'menu.property.sales.new.fire': 'Property',
    'menu.property.sales.new.liability': 'Liability',
    'menu.agency-liability': 'Agency Liability',
    'menu.professional-architect-engineer': 'Architect & Engineer Professional Liability',
    'menu.property.sales.new.guaranty': 'Guaranty',
    'menu.property.sales.new.engineering': 'Engineering',
    'menu.property.sales.new.banking': 'Banking',
    'menu.property.sales.new.agricultural': 'Agricultural',
    'menu.property.sales.new.reinsurance': 'Reinsurance',
    'menu.livestock-insurance': 'Livestock Insurance',
    'menu.crop-insurance': 'Crop Insurance',
    'menu.greenhouse-insurance': 'Greenhouse Insurance',
    'menu.device-insurance': 'Device Insurance',
    'menu.property.configurations.banks': 'Banks',

    'menu.liability': 'Liability',

    'menu.property.sales.list': 'List',
    'menu.property.sales.lista-e-drafteve': 'Draft List',
    'menu.property.claims': 'Claims',
    'menu.property.claims.new': 'New practice',
    'menu.property.claims.list': 'Claims List',
    'menu.property.claims.list-events': 'List of events',
    'menu.property.configurations': 'Configurations',
    'menu.property.configurations.fleets': 'Fleets',
    'menu.fire': 'Fire',
    'menu.public': 'Public',
    'menu.guaranty': 'Guaranty',

    'menu.health': 'Health',
    'menu.health.sales': 'Sales',
    'menu.health.sales.new': 'New Sales',
    'menu.health.sales.list': 'List',
    'menu.health.sales.lista-e-drafteve': 'Draft List',
    'menu.health.claims': 'Claims',
    'menu.health.claims.new': 'New practice',
    'menu.health.claims.list': 'Claims List',
    'menu.health.claims.list-events': 'List of events',
    'menu.health.configurations': 'Configurations',
    'menu.health.configurations.fleets': 'Fleets',
    'menu.private': 'Private Health',
    'menu.telehealth': 'Telehealth',
    'menu.motor.configurations.list': 'ADE List',
    'menu.travel': 'Health Travel',
    'menu.antitumor': 'Antitumor',
    'menu.life-plus': 'Life Plus',
    'menu.travel-embassy': 'Health Travel Embassy',

    'menu.marine': 'Marine',
    'menu.marine.sales': 'Sales',
    'menu.marine.sales.new': 'New Sales',
    'menu.marine.sales.list': 'List',
    'menu.marine.sales.lista-e-drafteve': 'Draft List',
    'menu.marine.sales.duplicate': 'Duplicate',
    'menu.marine.claims': 'Claims',
    'menu.marine.claims.new': 'New practice',
    'menu.marine.claims.list': 'Claims List',
    'menu.marine.claims.list-events': 'List of events',
    'menu.marine.configurations': 'Configurations',
    'menu.marine.configurations.fleets': 'Fleets',

    'menu.finance': 'Finance',
    'menu.finance.reconciliation': 'Reconciliation',
    'menu.finance.reconciliation.new': 'New Reconciliation',
    'menu.finance.reconciliation.list': 'List of reconciliations',
    'menu.finance.reports': 'Reports',
    'menu.finance.reports.daily': 'Daily',
    'menu.finance.reports.monthly': 'Monthly',
    'menu.finance.reports.yearly': 'Annual',
    'menu.finance.reports.custom': 'Dynamic',
    'menu.finance.invoices': 'Invoices',
    'menu.finance.failedInvoices': 'Failed Invoices',
    'menu.finance.bankAccount': 'Bank Account',

    'menu.contacts': 'Contacts',
    'menu.contacts.all': 'All',
    'menu.contacts.customers': 'Customers',
    'menu.contacts.agencies': 'Agencies',
    'menu.contacts.branches': 'Branches',
    'menu.contacts.hospital': 'Hospitals',
    'menu.contacts.intermediaries': 'Intermediaries',
    'menu.contacts.underwriters': 'Underwriters',
    'menu.contacts.insurers': 'Insurers',

    'menu.catalog': 'Catalog',
    'menu.catalog.products': 'Products',
    'menu.catalog.blocked-objects': 'Blocked Objects',
    'menu.catalog.communication-exclusions': 'Communication Exclusions',
    'menu.catalog.configurations': 'Configurations',
    'menu.catalog.template': 'Template',

    'menu.auth0': 'Auth0',
    'menu.auth0.users': 'Users',
    'menu.auth0.roles': 'Roles',
    'menu.auth0.permissions': 'Permissions',

    'menu.public-liability': 'Public Liability',
    'menu.product-liability': 'Product Liability',
    'menu.professional-liability': 'Professional Liability',
    'menu.employer-liability': 'Employer Liability',
    'menu.pollution-liability': 'Pollution Liability',
    'menu.other-liability': 'Other Liabilities',
    'menu.builder-liability-650': 'Builder Liability (VKM 650)',
    'menu.builder-liability-693': 'Builder Liability (VKM 693)',
    'menu.fuel-liability': 'Fuel Liability',
    'menu.directors-and-officers-liability': 'Directors and Officers Liability',
    'menu.notary': 'Notary',

    'menu.map': 'Map',
    'menu.map.albania': 'Albania',

    'menu.exception.403': '403',
    'menu.exception.404': '404',
    'menu.exception.500': '500',
    'menu.form': 'Form',
    'menu.form.basic-form': 'Basic Form',
    'menu.form.step-form': 'Step Form',
    'menu.form.step-form.info': 'Step Form(write transfer information)',
    'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
    'menu.form.step-form.result': 'Step Form(finished)',
    'menu.form.advanced-form': 'Advanced Form',
    'menu.list': 'List',
    'menu.list.table-list': 'Search Table',
    'menu.list.basic-list': 'Basic List',
    'menu.list.card-list': 'Card List',
    'menu.list.search-list': 'Search List',
    'menu.list.search-list.articles': 'Search List(articles)',
    'menu.list.search-list.projects': 'Search List(projects)',
    'menu.list.search-list.applications': 'Search List(applications)',
    'menu.profile': 'Profile',
    'menu.profile.basic': 'Basic Profile',
    'menu.profile.advanced': 'Advanced Profile',
    'menu.result': 'Result',
    'menu.result.success': 'Success',
    'menu.result.fail': 'Fail',
    'menu.exception': 'Exception',
    'menu.exception.not-permission': '403',
    'menu.exception.not-find': '404',
    'menu.exception.server-error': '500',
    'menu.exception.trigger': 'Trigger',
    'menu.account': 'Account',
    'menu.account.center': 'Account Center',
    'menu.account.settings': 'Account Settings',
    'menu.account.trigger': 'Trigger Error',
    'menu.account.logout': 'Logout',
    'menu.editor': 'Graphic Editor',
    'menu.editor.flow': 'Flow Editor',
    'menu.editor.mind': 'Mind Editor',
    'menu.editor.koni': 'Koni Editor',

    'menu.finance.reconciliation.invoices': 'Invoices',
    'menu.professional-liability-873/610': 'Professional Liability (VKM 873/610)',
    'menu.public-liability-873': 'Public Liability (VKM 873)',
    'menu.professional-insurance-agent': 'Professional Insurance Agent',
    'menu.catalog.single': 'Single',

    'menu.contract-guaranty': 'Contract Guaranty',
    'menu.licensing-guaranty': 'Licensing Guaranty',
    'menu.prepaid-guaranty': 'Prepaid Guaranty',
    'menu.rent-guaranty': 'Rent Guaranty',
    'menu.judicial-guaranty': 'Judicial Guaranty',
    'menu.bank-guaranty': 'Bank Anti Guaranty',

    'menu.offer-guaranty': 'Offer Guaranty',

    'menu.motor.configurations.vehicles': 'Vehicles',
    'pages.motor.Vehicles': 'Vehicles',
    'pages.motor.Add Vehicle': 'Add vehicle',

    'menu.daily-autosos': 'Daily Autosos',
    'menu.travel-albania': 'Health Travel Albania',

    'menu.claims': 'Claims',
    'menu.claims.specialists': 'Specialists',
    'menu.claims.list': 'Claims list',
    'menu.driver-accidents': 'Aksidentet e shoferit',
    'menu.personal-accidents': 'Aksidentet personale',
    'menu.property.configurations.cities': 'Cities',
    'menu.motor.sales.duplicate': 'Duplicate',
    'menu.public-accommodating-structures': 'Public Accommodating Structures',
    'menu.public-property-under-pressure-liability': 'Public Property Under Pressure Liability',
    'menu.public-neighbor-liability': 'Public Neighbor Liability',
    'menu.professional-doctor-liability': 'Professional Doctor Liability',
    'menu.public-product-employer-liability': 'Public Liability GTPL&PL&EL',
    'menu.professional-real-estate-appraiser-liability': 'Professional Real Estate Appraiser Liability',
    'menu.cit': 'CIT',
    'menu.cash-vault': 'Cash Vault',

    'menu.cyber': 'Cyber',
    'menu.do': 'D&O',

    'menu.professional-broker-liability': 'Professional Broker Liability',
    'menu.professional-lawyer-liability': 'Professional Lawyer Liability',
    'menu.professional-enforcement-officer-liability': 'Professional Enforcement Officer Liability',
    'menu.public-third-party-liability': 'Public Third Party Liability',

    'menu.professional-loss-assessor-liability': 'Professional Loss Assessor Liability',

    'menu.quality-guaranty': 'Qualty Guaranty',
    'menu.maintenance-guaranty': 'Maintanence Guaranty',
    'menu.customs-guaranty': 'Customs Guaranty',
    'menu.customs-warehouse-guaranty': 'Customs Warehouse Guaranty',
    'menu.excise-tax-guaranty': 'Excise Tax Guaranty',
    'menu.excise-tax-other-import-guaranty': 'Excise Tax Import Guaranty',
    'menu.iata-guaranty': 'Iata Guaranty',
    'menu.building-permit-guaranty': 'Building Permit Guaranty',
    'menu.waste-removal-guaranty': 'Waste Removal Guaranty',
    'menu.payment-guaranty': 'Payment Guaranty',
    'menu.concession-request-guaranty': 'Concession Request Guaranty',
    'menu.contacts.broker': 'Broker',
    'menu.motor.configurations.register': 'Register on ADE',
    'menu.professional-hiring-agency-liability': 'Professional Hiring Agency Liability',
    'menu.employers-liability': 'Employers Liability',

    'menu.finance.balance': 'Balances',
    'menu.finance.payments': 'Payments',

    'menu.import': 'Unimported policies',
    'menu.policy-renewals': 'Renewals',
    'menu.travel-plus': 'Travel Plus',
    'menu.tasks': 'Tasks',
};
